import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const articles = [{
  tag: 'OPERATIONS',
  title: 'The Case Against Spreadsheets in Modern Intelligence Workflows',
  excerpt: 'Why legacy tools are creating blind spots and how structured platforms are replacing them.',
  readTime: '4 MIN READ'
}, {
  tag: 'COMPLIANCE',
  title: 'What CJIS Alignment Really Means for Your RFI Process',
  excerpt: 'Navigating the security requirements for handling sensitive intelligence requests.',
  readTime: '6 MIN READ'
}, {
  tag: 'CASE STUDY',
  title: 'How Fusion Centers Are Cutting RFI Cycle Time in Half',
  excerpt: 'A look at the operational metrics before and after implementing structured workflows.',
  readTime: '5 MIN READ'
}];
export function Insights() {
  return <section id="insights" className="py-24 bg-iris-surface" data-id="element-148">
      <Container data-id="element-149">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-150">
          <div data-id="element-151">
            <SectionEyebrow text="Insights & Resources" className="mb-4" data-id="element-152" />
            <h2 className="text-4xl font-display font-bold text-white" data-id="element-153">
              INTELLIGENCE BRIEFINGS
            </h2>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-sm font-mono text-iris-green hover:text-iris-greenLight transition-colors" data-id="element-154">
            View all resources <ArrowRightIcon className="w-4 h-4" data-id="element-155" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-156">
          {articles.map((article, index) => <motion.a href="#" key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group block bg-iris-black border border-iris-border p-6 hover:border-iris-green transition-colors flex flex-col h-full" data-id="element-157">
              <div className="flex items-center justify-between mb-4" data-id="element-158">
                <span className="text-xs font-mono text-iris-green bg-iris-green/10 px-2 py-1" data-id="element-159">
                  {article.tag}
                </span>
                <span className="text-xs font-mono text-iris-muted" data-id="element-160">
                  {article.readTime}
                </span>
              </div>

              <h3 className="text-xl font-display font-bold text-white mb-3 group-hover:text-iris-green transition-colors" data-id="element-161">
                {article.title}
              </h3>

              <p className="text-sm text-iris-muted mb-6 flex-grow" data-id="element-162">
                {article.excerpt}
              </p>

              <div className="inline-flex items-center gap-2 text-sm font-mono text-iris-text group-hover:text-iris-green transition-colors mt-auto" data-id="element-163">
                Read Article <ArrowRightIcon className="w-4 h-4" data-id="element-164" />
              </div>
            </motion.a>)}
        </div>
      </Container>
    </section>;
}